import { moneyRequestProxyApi } from '@alfa-bank/newclick-api';
import { asyncAtom } from '@alfa-bank/newclick-core/atoms';
import { atom } from 'jotai';

import { type MoneyPoolData } from '../../types';
import { getFormatedAmount } from '../../utils/get-formated-amount';
import { getOwnerText } from '../../utils/get-owner-text';
import { getProgressInfo } from '../../utils/get-progress-info';

export const moneyPoolInitialAtom = atom<MoneyPoolData | undefined>(undefined);

export const moneyPoolDataAtom = asyncAtom({
    key: 'getMoneyPoolData',
    queryFn: async ({ publicId }: { publicId: string }, { get, set }) => {
        const moneyPoolInitial = get(moneyPoolInitialAtom);

        if (moneyPoolInitial) {
            set(moneyPoolInitialAtom, undefined);

            return moneyPoolInitial;
        }

        const response = await moneyRequestProxyApi.getMoneyPoolData({ publicId });

        return response.data;
    },
});

export const poolForEachAtom = atom((get) => {
    const moneyPoolData = get(moneyPoolDataAtom).data;

    if (moneyPoolData) {
        const { type, amountForEach, maxSumPayment } = moneyPoolData;

        const amount =
            (type === 'GOAL_TOTAL_FOR_EACH' || type === 'TOTAL_FOR_EACH') && amountForEach;

        const amountHint = amount
            ? `Рекомендуемая сумма — ${getFormatedAmount(amount)}`
            : `До ${getFormatedAmount(maxSumPayment)}`;

        return { amountForEach: amount, amountHint };
    }

    return {};
});

export const poolLimitsAtom = atom((get) => {
    const moneyPoolData = get(moneyPoolDataAtom).data;

    if (moneyPoolData) {
        return {
            maxSumPayment: moneyPoolData.maxSumPayment,
            goalAmountLimit: moneyPoolData.goalAmountLimit,
        };
    }

    return {};
});

export const poolInfoAtom = atom((get) => {
    const moneyPoolData = get(moneyPoolDataAtom).data;

    if (moneyPoolData) {
        const { ownerName, dueDate, comment, status, closedMoneyPool } = moneyPoolData;

        let ownerText = ownerName;
        const closedPool = status === 'CLOSED' && closedMoneyPool;

        if (!closedPool) {
            ownerText = getOwnerText(ownerName, dueDate);
        }

        return { ownerText, comment, closedPool };
    }

    return {};
});

export const poolProgressAtom = atom((get) => {
    const moneyPoolData = get(moneyPoolDataAtom).data;

    if (moneyPoolData) {
        const {
            type,
            goalAmount,
            remain,
            progressFilled,
            name,
            totalSum,
            categoryIcon,
            radianceColor,
            status,
        } = moneyPoolData;

        const activePool = status === 'ACTIVE';
        const progress = getProgressInfo({ type, goalAmount, remain, progressFilled });

        return { progress, name, totalSum, radianceColor, categoryIcon, activePool };
    }

    return {};
});

export const qrPageDataAtom = atom((get) => {
    const moneyPoolData = get(moneyPoolDataAtom).data;

    if (moneyPoolData) {
        return {
            comment: moneyPoolData.comment,
            categoryName: moneyPoolData.categoryName,
        };
    }

    return {};
});

export const ownerNameAtom = atom((get) => {
    const ownerName = get(moneyPoolDataAtom).data?.ownerName ?? '';

    return ownerName;
});
